import React from 'react';

import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import '../styles/custom.css';
import '../styles/shell.css';
import '../styles/navbar.css';
import '../styles/menu-typography.css';
import '../styles/button-theme.css';
import '../styles/form-actions.css';
import '../styles/themes.css';
import '../styles/theme-picker.css';
import '../styles/admin-mobile.css';
import '../styles/layout-refresh.css';

import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '../store/store';

import Body from '../components/body';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Body />
        <ToastContainer autoClose={3000} className="toast-container" />
      </PersistGate>
    </Provider>
  );
}

export default App;

